const defaultAvatars = [
  '/communities/images/placeholder/default_avatar_1.svg',
  '/communities/images/placeholder/default_avatar_2.svg',
  '/communities/images/placeholder/default_avatar_3.svg',
  '/communities/images/placeholder/default_avatar_4.svg',
];

export default defaultAvatars;
